import React from 'react';
import LocalizedStrings from 'react-localization';
import url from '../../img/9.png';
import urlWebp from '../../img/9.webp';

function MakeBanner(props) {
  const strings = new LocalizedStrings({
    ru: {
      make: 'Оформляй и зарабатывай!',
      txt: 'Оформи карту через POLIS.UA и получи персональный промокод на кешбек в 10% на оформление автогражданки',
    },
    ua: {
      make: 'Оформлюй та заробляй!',
      txt: 'Оформи карту через POLIS.UA та отримай персональний промокод на кешбек у 10% на оформлення автоцивілки',
    },
  });
  strings.setLanguage(props.locale);
  return (
    <div className="make-banner banner-block">
      <h3>{strings.make}</h3>
      <p>{strings.txt}</p>
      <div className="flex flex_j-flex-end">
        <div className="action">10%</div>
      </div>
      <div className="img img-car">
        <picture>
          <source srcSet={urlWebp} type="image/webp" />
          <img src={url} alt="car" />
        </picture>
      </div>
      <div className="bg">
        <svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 276 367" style={{ enableBackground: 'new 0 0 276 367' }} xmlSpace="preserve">
          <style type="text/css" dangerouslySetInnerHTML={{ __html: '\n                                        .st0{opacity:0.1;fill:url(#SVGID_1_);enable-background:new    ;}\n                                        .st1{fill:url(#SVGID_2_);}\n                                    ' }} />
          <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1={138} y1="367.8898" x2={138} y2="0.8898" gradientTransform="matrix(1 0 0 -1 0 367.8898)">
            <stop offset={0} style={{ stopColor: '#1487CF' }} />
            <stop offset="0.293" style={{ stopColor: '#1487CF' }} />
            <stop offset={1} style={{ stopColor: '#FFD83A' }} />
          </linearGradient>
          <path
            className="st0"
            d="M3,367h270c1.7,0,3-1.3,3-3V196.5c0-3.1-4.6-4.4-6.4-1.9c-5.7,7.7-14.6,17.1-23.1,16.2
                                  c-33.3-3.4-30.4-62.4-60.6-80.6c-27.6-16.6-68.1-2.6-94.2-22.9C55.8,79.4,70.2,2.3,3.1,0C1.4-0.1,0,1.3,0,3v361
                                  C0,365.7,1.3,367,3,367z"
          />
          <linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="2.5721" y1="132.9225" x2="293.3577" y2="133.9255" gradientTransform="matrix(1 0 0 -1 0 367.8898)">
            <stop offset={0} style={{ stopColor: '#1487CF' }} />
            <stop offset="0.2239" style={{ stopColor: '#1487CF' }} />
            <stop offset="0.8229" style={{ stopColor: '#FFD83A' }} />
          </linearGradient>
          <path
            className="st1"
            d="M3,367h270c1.7,0,3-1.3,3-3V236c0-2.5-2.8-3.9-4.9-2.6c-8,5.3-24.2,14.9-34.7,14.1
                                  c-33.3-2.7-21.4-44.2-51.6-58.5c-27.6-13.1-48.6,4.4-74.6-11.5c-35.9-21.9-39.5-74-107.1-75.5c-1.7,0-3.1,1.3-3.1,3v259
                                  C0,365.7,1.3,367,3,367z"
          />
        </svg>
      </div>
    </div>

  );
}

export default MakeBanner;
